import { createFileRoute } from '@tanstack/react-router'

import { ListPage } from '~/boundedContext/list/pages/list-page'
import { useExpandedStore } from '~/boundedContext/list/stores/expanded'

import { mainListPageSchema } from './-schemas/main-list-page-schema'

export const Route = createFileRoute('/_main-layout/list')({
  component: ListPage,
  validateSearch: search => mainListPageSchema.parse(search),
  beforeLoad: async ctx => {
    if (ctx.search.activeCardId) useExpandedStore.getState().add(ctx.search.activeCardId)
  },
})
